import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Trazabilidad/index`, method: 'POST', body: values, token: token})
}